export const API_URL = process.env.REACT_APP_API_URL;
export const FWPUBK = process.env.REACT_APP_FWPUBK;
export const PRFIMGBASE = process.env.REACT_APP_PRFIMGBASE;
